import API from './API';
import { POST } from '../utils/Executer';
import { SEARCH_V2_FETCH_LIMIT } from '../constants/search.constants';

const SEARCH_ENDPOINT = '/v1/search';

class SearchServiceAPI {
  /**
   * Search v2 (`POST /v1/search`).
   *
   * @param {object} [params]
   * @param {string} [params.query] - The search term.
   * @param {object} [params.filters] - API filters (see `mapFiltersToApi`).
   * @param {number} [params.limit] - Max hits, per bucket when grouped. Default `SEARCH_V2_FETCH_LIMIT`.
   * @param {number} [params.page] - Page number.
   * @param {'workspace'|'entityType'} [params.groupBy] - Bucket key.
   * @returns {Promise<{ success: boolean, data?: any, error?: any }>} The Executer envelope.
   * @example
   * await searchServiceAPI.search({ query: 'sepsis', groupBy: 'workspace' });
   */
  async search({ query, filters, limit = SEARCH_V2_FETCH_LIMIT, page, groupBy } = {}) {
    return await API.client.execute(POST, SEARCH_ENDPOINT, {
      query,
      filters,
      limit,
      page,
      groupBy,
    });
  }
}

export default new SearchServiceAPI();
